/**
 * Модель для работы с анкерами
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

import { IId, ICoordXY, IBeacon, IBeaconType, IOffice } from './types';
import BeaconsService, { IUpdateOrCreateBody } from '../services/BeaconsService';
import MapsService from '../services/MapsService';

export interface IData {
  types: IBeaconType[];
  offices: IOffice[];
}

interface IState {
  data: IData;
  item: IBeacon | null;
  coordinates: ICoordXY | null;
}

const initialState: IState = {
  data: {
    types: [],
    offices: []
  },
  item: null,
  coordinates: null
};

export const infrastructureBeacons = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setData(state: IState, payload: IData): IState {
      return { ...state, data: payload };
    },
    setItem(state: IState, payload: IBeacon): IState {
      return { ...state, item: payload };
    },
    setCoordinates(state: IState, payload: ICoordXY): IState {
      return { ...state, coordinates: payload };
    },
    reset(): IState {
      return initialState;
    }
  },
  effects: (dispatch: any) => ({
      async getData() {
        const [
          { data: types },
          {
            data: { data: offices }
          }
        ] = await Promise.all([
          BeaconsService.getTypeAll({ hideSpecial: true }),
          MapsService.getOffices()
        ]);

        this.setData({ types, offices });
      },
      async getItem(mac: IId) {
        const { data } = await BeaconsService.get(mac);

        this.setItem(data);
      },
      async updateOrCreate(body: IUpdateOrCreateBody) {
        try {
          await BeaconsService.updateOrCreate(body);
          await dispatch.infrastructureMap.getMap();
        } catch (error) {
          return error;
        }
      },
      async remove(id: IId, _rootState?: any) {
        try {
          await BeaconsService.remove(id);
          await dispatch.infrastructureMap.getMap();
        } catch (error) {
          return error;
        }
      },
      focus(center: ICoordXY) {
        // const payload = { zoom: 20, center };
        const payload = { center };
        dispatch.infrastructureMap.setFocus(payload);
      }
    })
});
